// src/app/components/MaintenancePage.tsx
'use client'; // Mark as client component

import React, { useState, useEffect } from 'react';
import { Logo } from '@fsg/svg'; // Import the FSG Logo component

const MaintenancePage = () => {
  const [countdown, setCountdown] = useState(10); // Countdown state

  useEffect(() => {
    // Set interval to decrement countdown every second
    const intervalId = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          // When countdown reaches 0 (or less), reload the page
          window.location.reload();
          return 10; // Reset for the next potential interval (though reload happens first)
        }
        return prevCountdown - 1;
      });
    }, 1000); // 1000ms = 1 second

    // Cleanup function to clear interval on unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-5 text-center">
      <Logo className="w-24 h-24 mb-6 text-blue-600" /> {/* Adjust size and color as needed */}

      <h1 className="text-4xl font-bold text-gray-800 mb-4"> {/* Tailwind classes for heading */}
        Under Maintenance
      </h1>
      <p className="text-lg text-gray-600 max-w-xl mb-6"> {/* Added margin bottom */}
        We are currently performing scheduled maintenance. We should be back online shortly. Thank you for your patience!
      </p>
      {/* Display the countdown timer */}
      <div className="mt-4 text-sm text-gray-500"> {/* Added margin top */}
        Automatically refreshing in {countdown} seconds...
        {/* Optional: Add a simple visual spinner/loader here */}
        <div className="inline-block ml-2 animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-gray-500"></div>
      </div>
    </div>
  );
};

export default MaintenancePage;
